import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-317a19b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "row q-gutter-sm" }

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperFooter',
  setup(__props) {

const model = ref(null);

let options = [];

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "iodine-footer" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_space),
        _createVNode(_component_q_form, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createVNode(_component_q_select, {
                    outlined: "",
                    dense: "",
                    modelValue: model.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
                    options: _unref(options),
                    label: "Save As",
                    class: "drg-save-as"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    unelevated: "",
                    class: "iodine-submit-button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Submit")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})